import objectives from './objectives/sliceSaga';

import { all } from 'typed-redux-saga';

export default function* saga() {
  const sagas = [objectives.saga];

  yield* all(sagas);
}
